const useObtenerTiposDanios = [
    { Id: 1, Descripcion: 'Mojado' },
    { Id: 1, Descripcion: 'Roto' },
    { Id: 1, Descripcion: 'Otro' },
];

export default useObtenerTiposDanios;
